import { Component } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-pass-reset',
  templateUrl: './pass-reset.component.html',
  styleUrls: ['./pass-reset.component.scss']
})
export class PassResetComponent {

  public username: string = '';
  public message: string = '';
  showLoader:boolean | undefined;

  constructor(public authService : AuthService,){}

  resetPassword(){
    this.showLoader = true;
    this.authService.resetPassword(this.username)
    .subscribe(() =>{
      this.message = "E-mail enviado com sua nova senha!";
      this.showLoader = false;
    });
  }
}
